/**
 * Route for `post-attribution-fraud-detection`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PostAttributionFraudDetectionPage } from "../features/post-attribution-fraud-detection/PostAttributionFraudDetectionPage";

export const postAttributionFraudDetectionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/post-attribution-fraud-detection",
	component: PostAttributionFraudDetectionPage,
});

export default postAttributionFraudDetectionRoute;
